import styled from 'styled-components';

export const Box = styled.div<{ $hasBottomMargin?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
